import React from 'react';
import PropTypes from 'prop-types';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import Stepper from '../../../Stepper';
import MailInCircleIcon from '../../../../../MailInCircleIcon';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    inner: PropTypes.string,
    heading: PropTypes.string,
    statusBox: PropTypes.string,
    main: PropTypes.string,
  }).isRequired,
};

export const StepThree = props => {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <h1 className={classes.heading}>
          <MailInCircleIcon />
        </h1>
        <div className={classes.main}>
          {/* we may bring the statusBox below back later on, so for now, I just comment it out */}
          {/* <div className={classes.statusBox}>ACCOUNT STATUS: PENDING</div> */}
          <div className={classes.warningMessage}>
            <WarningIcon /> <span>Email verification</span>
          </div>
          <div className={classes.stepper}>
            <Stepper />
          </div>
        </div>
      </div>
    </div>
  );
};

StepThree.propTypes = propTypes;

export default withStyles(styles)(StepThree);
